
export const getCookie=(name:string)=> {
    return Office.context.roamingSettings.get(name);;
}
